/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { DirtyType } from '@gh/common-shared-data';
import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  GraphicalTakeOffHousePlanSaveDto,
  GraphicalTakeOffHousePlanViewDto,
  GraphicalTakeOffTopViewSaveDto,
} from './dto';

export const GraphicalTakeOffHousePlanViewMapper = entity<GraphicalTakeOffHousePlanViewDto>();

export const GraphicalTakeOffHousePlanSaveMapper = entity<GraphicalTakeOffHousePlanSaveDto>({
  tops: arrayOf(subentity<GraphicalTakeOffTopViewSaveDto>({
    dirtyType: enumeration(DirtyType),
  })),
});
